import { undo, redo, undoWithBlockers, type HistoryOutcome } from './history';

interface ToastAction { label: string; onClick: () => void }
/** The two toast kinds an outcome needs; matches useToast(). */
export interface Toasts {
  info: (message: string, action?: ToastAction) => void;
  error: (message: string, action?: ToastAction) => void;
}

/** Shows the outcome of an undo/redo, with the opposite action or "Undo those first". */
export function reportOutcome(toast: Toasts, r: HistoryOutcome, verb: 'undo' | 'redo'): void {
  if (r.ok) {
    const again = verb === 'undo'
      ? { label: 'Redo', onClick: () => { void redo(r.id).then((o) => reportOutcome(toast, o, 'redo')); } }
      : { label: 'Undo', onClick: () => { void undo(r.id).then((o) => reportOutcome(toast, o, 'undo')); } };
    toast.info(`${verb === 'undo' ? 'Undid' : 'Redid'}: ${r.label}`, again);
    return;
  }
  if (r.status === 404) {
    toast.info(verb === 'undo' ? 'Nothing to undo' : 'Nothing to redo');
    return;
  }
  const refusedId = r.actionId;
  if (verb === 'undo' && refusedId && r.blockers.some((b) => b.id)) {
    toast.error(r.error, {
      label: 'Undo those first',
      onClick: () => { void undoWithBlockers(refusedId, r.blockers).then((o) => reportOutcome(toast, o, 'undo')); },
    });
    return;
  }
  toast.error(r.error);
}

